var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"notifications"}},[_c('transition',{attrs:{"name":"v-toast","appear":""}},[(!_vm.hide)?_c('div',{class:[
        'v-toast',
        _vm.success && 'v-toast--success',
        _vm.info && 'v-toast--info',
        _vm.error && 'v-toast--error'
      ],on:{"click":function($event){return _vm.hideToast()}}},[_c('div',{staticClass:"v-toast__icon"},[(_vm.success)?_c('v-icon',{attrs:{"name":"success"}}):(_vm.error)?_c('v-icon',{attrs:{"name":"error"}}):_c('v-icon',{attrs:{"name":"info"}})],1),_c('v-text',{staticClass:"v-toast__content",attrs:{"font-size":"2"}},[_vm._t("default")],2),(_vm.dismissible)?_c('v-icon',{staticClass:"v-toast__close",attrs:{"name":"close","size":"xxsmall"}}):_vm._e()],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }